import api from '../../plugins/api';

const getMarks = (params) => {
  return api.get('/api/crm/cars/getMarks', params);
};

export default getMarks;
